<div class="account">
  <fa-icon [icon]="faBank"></fa-icon>
  <div class="info">
    <h4>{{account}}</h4>
    <p>{{owner}}</p>
  </div>
  <fa-icon [icon]="faTrash" (click)="onClick.emit()"></fa-icon>
</div>
